/* eslint-disable @typescript-eslint/naming-convention */
import "../../../wwwroot/lib/sha256.js";
import "../../../wwwroot/lib/auth0/jwt-decode.js";

// Note: this file has been modified locally! It is fixed to work with webpack, but
// most optimally it should be installed via npm along with the correct typings.
import auth0 from "../../../wwwroot/lib/auth0/auth0.9.4.2.js";

// TODO: These typings are here until we install auth0 library via npmjs.
// They are written in a custom manner and are by no means complete.
// Always check the source code to determine the truth.

export interface IAuthResult {
  accessToken?: string;
  idToken?: string;
  idTokenPayload?: IIdTokenPayload;
  invitationKey?: string;
}

export interface IIdTokenPayload {
  sub?: string;
  [customProp: string]: unknown;
}

interface IAuth0WebAuth {
  authorize(args: {
    domain?: string;
    clientID?: string;
    redirectUri?: string;
    responseType?: string;
    responseMode?: string;
    state?: string;
    nonce?: string;
    scope?: string;
    audience?: string;
    [key: string]: string;
  }): void;

  parseHash(
    opts: { hash: string; state?: string; nonce?: string; __enableIdPInitiatedLogin?: boolean },
    callback: (err: Record<string, unknown>, authResult: IAuthResult) => void
  ): void;
}

interface IAuth0Authentication {
  buildAuthorizeUrl(opts: { connection?: string; login_hint?: string; state?: string; nonce?: string; [key: string]: string }): string;
}

interface IAuth0WebAuthCtor {
  prototype: IAuth0WebAuth;
  new (opts: { clientID: string; domain: string; scope: string; responseType: string; redirectUri?: string; responseMode?: string; audience?: string }): IAuth0WebAuth;
}

interface IAuth0AuthenticationCtor {
  new (opts: {
    clientID: string;
    domain: string;
    scope: string;
    responseType: string;
    redirectUri?: string;
    responseMode?: string;
    audience?: string;
  }): IAuth0Authentication;
}

interface IAuth0Static {
  WebAuth: IAuth0WebAuthCtor;
  Authentication: IAuth0AuthenticationCtor;
}
//Should be removed after switching to new authentication
export default auth0 as unknown as IAuth0Static;
